// extracted by mini-css-extract-plugin
module.exports = {"similar":"UsedCarPage_similar__Ir1Ew"};